<template lang="pug">
.layout
  y-dialog(v-if="showModal" v-model="showModal" scrollable max-width="600px" persistent)
    v-card
      v-card-title.px-4
        div.h6.basic800--text {{ $t('extra_field_filter') }}
      v-divider.basic300
      v-card-text.pa-4
        .field-type
          p.mb-2.label.basic600--text.text-uppercase {{ $t('filter_by') }} 
          v-select(v-model="extraFieldType" :items="fieldTypes" item-text="text" item-value="value" background-color="basic200" height="40" item-color="basic100" outlined dense hide-details)
            template(v-slot:append)
              eva-icon(name="chevron-down-outline" width="24" height="24" :fill="$vuetify.theme.themes[$theme].basic700")
        
        .extra-info.mt-6(v-if="extraFieldType === 'date'")
          v-date-picker(v-model="filterDate" color="textColorAccent" no-title)
        
        .extra-info.mt-6(v-else-if="extraFieldType === 'time'")
          v-text-field(v-model="filterTime" placeholder="Filter time" hide-details dense outlined height="40" background-color="basic200" type="time")
        
        .extra-info.mt-6(v-else)
          v-text-field(v-model="filterText" placeholder='Filter text' hide-details dense outlined height="40" background-color="basic200")

      v-card-actions
        v-spacer
        v-btn(color='white', text @click='showModal = false')
          .button-Aa-small.primary400--text {{ $t('close') }}
        v-btn.mr-2(v-if="filterText" color='textColorAccent' depressed height=32 @click="updateFilter" dark)
          .button-AA-small.basic100--text {{ $t('filter') }}

</template>

<script>
export default {
  name: 'ExtraFieldFilter',
  props: ['open', 'field'],
  data: () => ({
    filterText: '',
    filterTime: null,
    filterDate: null,
    extraFieldType: 'text',
    fieldTypes: [
      { 
        index: 0,
        text: 'Text',
        value: 'text'
      },
      { 
        index: 1,
        text: 'Date',
        value: 'date'
      },
      { 
        index: 2,
        text: 'Time',
        value: 'time'
      }
    ]
  }),
  computed: {
    showModal: {
      get() {
        return this.open
      },
      set(newValue) {
        this.$emit('update:open', newValue)
      }
    },
    extraFieldData () {
      return [this.extraFieldType, this.filterText]
    }
  },
  watch: {
    filterTime (val) {
      this.filterText = this.formatTime(val)
    },
    filterDate (val) {
      this.filterText = this.formatDate(val)
      this.updateFilter()
    }
  },
  methods: {
    updateFilter () {
      this.$emit('selected', this.extraFieldData)
      this.showModal = false
    },
    formatDate (date) {
      if (!date) {
        return null
      }
      const [year, month, day] = date.split('-')
      return `${day}/${month}/${year}`
    },
    formatTime (time24) {
      let ts = time24
      const H = +ts.substr(0, 2)
      let h = (H % 12) || 12
      h = (h < 10) ? ('0' + h) : h
      const ampm = H < 12 ? 'AM' : 'PM'
      ts = h + ':' + ts.substr(3, 2) + ampm
      return ts
    }
  }
}
</script>

<style scoped>
.v-text-field--outlined >>> fieldset {
  border-color: var(--v-primary200);
}
.error--text >>> fieldset {
  border-color: var(--v-danger);
}
div >>> .v-list-item--active{
  background-color: var(--v-info500) !important;
  color:white;
}
</style>

<i18n>
{
  "en": {
    "extra_field_filter": "Extra Field Filter",
    "filter_by": "filter by"
  },
  "id": {
    "extra_field_filter": "Filter info tambahan",
    "filter_by": "filter by"
  }
}
</i18n>
